import React from "react";
import { DotLegalMultiSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation.ts";
import { InformationSecurityProperty } from "../../../incidentLog/IncidentLogDialog.types.ts";
import { useIncidentLogAffectedSecurityPropertiesField } from "./IncidentLogAffectedSecurityPropertiesField.hooks.ts";

export interface IncidentLogAffectedSecurityPropertiesFieldProps {
    affectedSecurityProperties: Array<InformationSecurityProperty>;
    onChange: (affectedSecurityProperties: Array<InformationSecurityProperty>) => void;
    disabled: boolean;
    errorText?: string;
}

function IncidentLogAffectedSecurityPropertiesField(props: IncidentLogAffectedSecurityPropertiesFieldProps) {
    const { translateString } = useTranslation();
    const { options, chosenOptions, onChange } = useIncidentLogAffectedSecurityPropertiesField(props);

    return (
        <DotLegalMultiSelect
            options={options}
            chosenOptions={chosenOptions}
            onChange={onChange}
            label={translateString("affectedSecurityPropertiesLabel")}
            toolTipText={translateString("affectedSecurityPropertiesHelpText")}
            noOptionsLabel={translateString("noOptions")}
            disabled={props.disabled}
            errorText={props.errorText}
        />
    );
}

export default IncidentLogAffectedSecurityPropertiesField;
